export interface Idol {
  assetId: number;
  address: string;
  name?: string;
  description?: string;
  mainImageUrl?: string;
  featuredImageUrl?: string;
  category?: string;
  facebookUrl?: string;
  twitterUrl?: string;
  instagramUrl?: string;
  fannel?: true;
  uid?: string;
  star?: number;
}

export interface Settings {
  fingerprint: boolean;
  notifications: boolean;
}

export interface Token {
  assetId: number;
  owner: string;
  issuer: string;
  title: string;
  last_price: number;
  next_price: number;
  status: TokenStatus;
  image?: string;
  sha1?: string;
  subtitle?: string;
  description?: string;
  length?: number;
  date?: Date;
  verified?: boolean;
  mint?: string;
}

export enum TokenStatus {
  Released,
  ForSale,
  Unfungible
}

export interface Transaction {
  from: string;
  to: string;
  amount?: object;
  value?: number;
  data?: object;
}

export interface User {
  uid: string;
  address?: string;
  displayName?: string;
  photoURL?: string;
  email?: string;
}

export interface Wallet {
  address: string;
  mnemonic: string;
  ethers?: number;
  watacoins?: number;
}

export const CATEGORIES = [
  "Deporte",
  "Música",
  "Cine",
  "TV",
  "Influencer",
  "Arte",
  "Marcas",
  "Periodista",
  "Moda",
  "Educación",
  "Tecnología"
];



// WEBPACK FOOTER //
// ./src/app/app.models.ts